/** Shared math utilities — replaces duplicated helpers across modules. */

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

export const clamp01 = (v) => Math.max(0, Math.min(1, Number(v) || 0));

export const lerp = (a, b, t) => a + (b - a) * t;

export const smooth = (t) => t * t * (3 - 2 * t);

export const rand = (a, b) => a + Math.random() * (b - a);
